import api from 'configs/api';
import { API_URLS } from 'constants/urls';
import {
  TRequestResponse,
  TRequestParams,
  TEmptyResponse,
} from 'types/services/common';
import { SetUserFlagProps, Flags } from 'types/services/user';
import { setUrlParams } from 'utils/urlParams';

export const userService = {
  getUserFlags: (queryParams: string[]): TRequestResponse<Flags> => {
    const queryParam = setUrlParams(
      {
        keys: queryParams.join(','),
      },
      false
    );
    return api.get(`${API_URLS.USER_DATA}?${queryParam}`, { timeout: 2000 });
  },
  setUserFlag: ({
    params,
  }: TRequestParams<SetUserFlagProps>): TRequestResponse<TEmptyResponse> =>
    api.post(API_URLS.USER_DATA, params),
};
